import React from 'react';
import { FaRegTrashAlt } from 'react-icons/fa';
import { CartItem } from '../../product/context/ProductContext.tsx';
import { getOptionLabel } from '../../product/ProductType.ts';
import { formatPriceWithDots } from '../../utils/utils.ts';

interface Props {
  item: CartItem;
  showDeleteButton?: boolean;
  onDelete?: (productId: string, purchaseOption: string) => void;
}

const CartItemRowDesktop: React.FC<Props> = ({
  item,
  showDeleteButton,
  onDelete,
}) => (
  <div className="shopping-cart-item">
    <span className="product-name">{item.product.name}</span>
    <span className="option-label">{getOptionLabel(item.purchaseOption)}</span>
    <span className="quantity">{item.quantity}</span>
    <span className="unit-price">
      ${formatPriceWithDots(item.partialPrice)}
    </span>
    <span className="total-price">
      ${formatPriceWithDots(item.partialPrice * item.quantity)}
    </span>
    {showDeleteButton && (
      <button onClick={() => onDelete?.(item.product.id, item.purchaseOption)}>
        <FaRegTrashAlt />
      </button>
    )}
  </div>
);

export default CartItemRowDesktop;
